import { render, staticRenderFns } from "./FoqcSet.vue?vue&type=template&id=1b1a5ffd"
import script from "./FoqcSet.vue?vue&type=script&lang=js"
export * from "./FoqcSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports